import { sendUpdateOrderBranch } from "@/models/socket/orders.model";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shadcn/components/ui/alert-dialog";
import { Button } from "@/shadcn/components/ui/button";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils.util";
import React, { useState } from "react";

type SelectBranchConfirmationDialogProps = {
  onClose: () => void;
  onConfirm: (branchID: string) => void;
  newBranchID: string;
  orderID: string;
  newBranchName: string;
};

const SelectBranchConfirmationDialog: React.FC<
  SelectBranchConfirmationDialogProps
> = ({ onClose, onConfirm, newBranchID, orderID, newBranchName }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleChangeBranch() {
    setSubmitting(true);
    setError(null);
    const response = await sendUpdateOrderBranch({
      branchID: newBranchID,
      orderID: orderID,
    });
    if (response.rStatus === "success") {
      onConfirm(newBranchID);
      genericSuccessToast("Order branch updated successfully");
    } else {
      console.error(
        response.rData ||
          "Failed to update order branch. Please try again later."
      );
      genericFailureToast(
        response.rData ||
          "Failed to update order branch. Please try again later."
      );
      setError(response.rData || "Failed to update order branch");
    }
    setSubmitting(false);
  }

  return (
    <AlertDialog
      open={true}
      onOpenChange={(open) => {
        if (!open) {
          setTimeout(() => {
            onClose(); // call onClose when dialog is closed
          }, 100); // reset state after dialog closes
        }
      }}
    >
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm Branch Change</AlertDialogTitle>
          <AlertDialogDescription></AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-4">
          <p>
            Are you sure you want to confirm changing the order branch to{" "}
            <span className="font-semibold">{newBranchName}</span>?
          </p>
          {error && <div className="text-sm text-red-500">{error}</div>}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button
            className=""
            onClick={handleChangeBranch}
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Confirm"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SelectBranchConfirmationDialog;
